import 'react/jsx-runtime';
import './components/InputError.module.scss.js';
import 'clsx';
import 'tslib';
import 'react';
import 'primereact/tooltip';
import './components/InputLabel.module.scss.js';
import { renderOverflowTooltipLabel } from './components/OverflowTooltipLabel.js';

function createOverflowItemTemplate(_ref) {
  let {
    enabled,
    getLabel,
    className,
    fallbackTemplate
  } = _ref;
  if (!enabled) {
    return fallbackTemplate;
  }
  return function (item) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return renderOverflowTooltipLabel(getLabel(item), className);
  };
}
function createOverflowValueTemplate(_ref2) {
  let {
    enabled,
    getLabel,
    className,
    fallbackTemplate,
    renderEmpty
  } = _ref2;
  if (!enabled) {
    return fallbackTemplate;
  }
  return function (item, templateProps) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }
    if (item === null || typeof item === 'undefined') {
      return renderEmpty ? renderEmpty(templateProps) : null;
    }
    return renderOverflowTooltipLabel(getLabel(item), className);
  };
}

export { createOverflowItemTemplate, createOverflowValueTemplate };
